import React, { useEffect, useState } from "react";
import {
  getAllOperators,
  deleteOperator,
  updateOperatorStatus,
} from "../services/operatorService";

import "./OperatorsList.css";

export default function OperatorsList() {
  const [operators, setOperators] = useState([]);
  const [loading, setLoading] = useState(true);
  const [deletingId, setDeletingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  async function loadOperators() {
    setLoading(true);
    const data = await getAllOperators();
    setOperators(data);
    setLoading(false);
  }

  useEffect(() => {
    loadOperators();
  }, []);

  async function handleDelete(id) {
    if (!window.confirm("Deseja realmente excluir este atendente?")) return;

    try {
      setDeletingId(id);
      await deleteOperator(id);
      await loadOperators();
    } catch (e) {
      console.error(e);
      alert("Erro ao excluir atendente.");
    } finally {
      setDeletingId(null);
    }
  }

  async function handleStatusChange(id, status) {
    try {
      await updateOperatorStatus(id, status);
      await loadOperators();
    } catch (e) {
      console.error(e);
      alert("Erro ao alterar status.");
    }
  }

  // Filtrar atendentes por termo de busca - CORRIGIDO
  const filteredOperators = operators.filter(op => {
    // Verificar se op existe e tem propriedades
    if (!op) return false;
    
    const name = op.name || "";
    const email = op.email || "";
    const role = op.role || "";
    
    const term = searchTerm.toLowerCase();
    
    return (
      name.toLowerCase().includes(term) ||
      email.toLowerCase().includes(term) ||
      role.toLowerCase().includes(term)
    );
  });

  return (
    <div className="operators-list-container">
      <header className="operators-header">
        <h1>Atendentes</h1>
        <p>
          Gerencie os atendentes responsáveis pelo atendimento via IA do Amor.
        </p>
      </header>

      {/* Barra de busca */}
      <div className="controls-bar">
        <input 
          type="text" 
          className="search-input" 
          placeholder="Buscar por nome, email ou cargo..." 
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div style={{ fontSize: '14px', color: '#666' }}>
          {filteredOperators.length} de {operators.length} atendentes
        </div>
      </div>

      {loading ? (
        <p className="loading">Carregando atendentes...</p>
      ) : filteredOperators.length === 0 ? (
        <div className="no-data">
          <p>{searchTerm ? "Nenhum atendente encontrado para sua busca." : "Nenhum atendente encontrado."}</p>
        </div>
      ) : (
        <div className="operators-table-wrapper">
          <table className="operators-table">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Email</th>
                <th>Status</th>
                <th>Cargo</th>
                <th>Ações</th>
              </tr>
            </thead>

            <tbody>
              {filteredOperators.map((op) => (
                <tr key={op.id}>
                  <td>
                    <div style={{ fontWeight: '600' }}>{op.name || "Sem nome"}</div>
                    {op.id && (
                      <div style={{ fontSize: '12px', color: '#666', marginTop: '4px' }}>
                        ID: {op.id.substring(0, 8)}...
                      </div>
                    )}
                  </td>
                  <td>{op.email || "—"}</td>

                  <td>
                    <span className={`status-badge ${op.status || "offline"}`}>
                      {op.status === "online"
                        ? "Online"
                        : op.status === "busy"
                        ? "Em atendimento"
                        : "Offline"}
                    </span>
                  </td>

                  <td>
                    <span className={`role-badge ${op.role || "atendente"}`}>
                      {op.role === "admin"
                        ? "Administrador"
                        : op.role === "supervisor"
                        ? "Supervisor"
                        : "Atendente"}
                    </span>
                  </td>

                  <td className="actions-col">
                    {/* STATUS */}
                    <select
                      value={op.status || "offline"}
                      onChange={(e) =>
                        handleStatusChange(op.id, e.target.value)
                      }
                      className="status-select"
                    >
                      <option value="online">Online</option>
                      <option value="busy">Em atendimento</option>
                      <option value="offline">Offline</option>
                    </select>

                    {/* EXCLUIR */}
                    <button
                      className="btn-delete"
                      onClick={() => handleDelete(op.id)}
                      disabled={deletingId === op.id}
                    >
                      {deletingId === op.id ? "Excluindo..." : "Excluir"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}